import React, {useState} from 'react';
import { useMe } from "context/MeContext";
import { css } from '@emotion/react';
import { List } from "@pankod/refine-antd";
import "../../../App.scss"
import "./menu-main.scoped.scss"
import RouterProvider from "@pankod/refine-react-router-v6";
import core from "../../../assets/img/core5.svg"
import content from "../../../assets/img/content4.svg"
import system from "../../../assets/img/system1.svg"
import chat from "../../../assets/img/chat5.svg"


const { Link } = RouterProvider;
export const MainMenu: React.FC = () => {
  const { me } = useMe();
  const isSuperAdmin = me?.isOps
  return (
    <List title={<h1 style={{fontSize: 35, marginTop:20, color:"rgb(4, 6, 10, 0.8)"}}>Overview</h1>}>
      <div className="d2-grid" css={css`margin: 0 40px;`}>
        {/* card */}
        {/* {menuMain.map((item, index) => (
          <AdminCard
            key={index}
            url={item.url}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))} */}
      <div className="card-main">
        <div className="card-content j-between">
          <div className="card-text">
            <Link to="/admin/core-management" className="card-title">Core Management</Link>
            <div className='card-list'>
              <Link to="/admin/core-management/dashboard" className="card-description">Dashboard</Link>
              <Link to="/admin/core-management/user" className="card-description">Users</Link>
              {isSuperAdmin && <Link to="/admin/core-management/company" className="card-description">Companies</Link>}        
            </div>
          </div>
          <Link to="/admin/core-management" className="card-icon"><img src={core} alt="" /></Link>
        </div>
      </div>

      <div className="card-main">
        <div className="card-content j-between">
          <div className="card-text">
            <Link to="/admin/system" className="card-title">System Controls</Link>
            <div className="card-list">
              <Link to="/admin/system/notifications" className="card-description">Notifications</Link>
              {isSuperAdmin && <Link to="/admin/system/white-email" className="card-description">Whitelist</Link>}
              <Link to="/admin/system/metadata" className="card-description">Metadata</Link>
            </div>
          </div>
          <Link to="/admin/system" className="card-icon"><img src={system} alt="" /></Link>   
        </div>
      </div>

      <div className="card-main">
        <div className="card-content j-between">
          <div className="card-text">
            <Link to="/admin/content-management" className="card-title">Content Management</Link>
            <div className="card-list">
              <Link to="/admin/content-management/challenge" className="card-description">Challenges</Link>
              {isSuperAdmin && <Link to="/admin/content-management/resources" className="card-description">Resources</Link>}
              <Link to="/admin/content-management/activity" className="card-description">Activities</Link>
              <Link to="/admin/content-management/trophy" className="card-description">Trophies Setting</Link>
              <Link to="/admin/content-management/icons" className="card-description">Icons Settings</Link>
              <Link to="/admin/content-management/hraadmin" className="card-description">Graph Settings</Link>
              {isSuperAdmin && <Link to="/admin/content-management/question" className="card-description">HRA Questions</Link>}
              {isSuperAdmin && <Link to="/admin/content-management/dimension" className="card-description">HRA Dimensions</Link>}
            </div>
          </div>
          <Link to="/admin/content-management" className="card-icon"><img src={content} alt="" /></Link> 
        </div>
      </div>

      <div className="card-main">
        <div className="card-content j-between">
          <div className="card-text">
            <Link to="/admin/chat-center" className="card-title">Chat Center</Link>
            <div className="card-list">
              <Link to="/admin/chat-center/category" className="card-description">Category</Link>
              <Link to="/admin/chat-center/topic" className="card-description">Topic</Link>
              <Link to="/admin/chat-center/post" className="card-description">Post</Link>
              <Link to="/admin/chat-center/message" className="card-description">Message</Link>
            </div>
          </div>
            <Link to="/admin/chat-center" className="card-icon"><img src={chat} alt=""/></Link>   
        </div>
      </div>

      </div>
    </List>
  );
};
